import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../store/action/auth';
import {
    getAdminOrdersByStatus
} from '../../store/action/order';
import AdminOrderTable from '../../components/tables/AdminOrderTable';
import {CSVLink} from "react-csv";

const AdminOrderByStatus = (props) => {
    const { token } = isAuthenticated();
    const [show, setShow] = useState(false);
    const [loading, setLoading ] = useState(true);
    const [orders, setOrders] = useState([]);
    const [downloadOrders, setDownloadOrders] = useState([]);

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        const resOr = await getAdminOrdersByStatus(props.match.params.status,token);
        if(resOr.orders.length > 0){
            let orders = resOr.orders.reduce((result, i, idx) => {
                result.push({
                    orderId: i._id,
                    userId: i.userId,
                    shipperName: i.shipper.name,
                    shipperPhone: i.shipper.phone,
                    shipperEmail: i.shipper.email,
                    shipperOrganization: i.shipper.organization,
                    receiverName: i.receiver.name,
                    receiverPhone: i.receiver.phone,
                    receiverEmail: i.receiver.email,
                    receiverLocation: i.receiver.location,
                    receiverNote: i.receiver.note,
                    originName: i.origin.name,
                    originLocation: i.origin.location,
                    originNote: i.origin.note,
                    originPhone: i.origin.phone,
                    orderType: i.type,
                    items: i.items,
                    paymentSlip: i.images.paymentSlip,
                    price: i.price,
                    courierTrackingId: i.courier.trackingId,
                    courierCompany: i.courier.company,
                    courierName: i.courier.name,
                    courierPhone: i.courier.phone,
                    courierType: i.courier.type,
                    courierWaybillId: i.courier.waybillId,
                    createdAt: i.createdAt,
                    deliveryType: i.delivery.type,
                    deliveryDate: i.delivery.date,
                    deliveryTime: i.delivery.time,
                    deliveryNote: i.delivery.note,
                    weight: i.weight,
                    volume: i.volume,
                    paymentType: i.paymentType,
                    receiptLink: i.receiptLink,
                    note:i.note,
                    status: i.status,
                    updatedAt: i.updatedAt
                });
                return result
            }, []);

            orders = orders.sort((a, b) => {
                var dateA = new Date(a.deliveryDate);
                var dateB = new Date(b.deliveryDate);
                return dateB - dateA;
            });

            let downloadable = orders.reduce((res, i) => {
                res.push({
                    ...i,
                    items: JSON.stringify(i.items)
                });
                return res
            },[]);

            setOrders(orders);
            setDownloadOrders(downloadable);
            setLoading(false)
        } else if (resOr.orders.length === 0) {
            return alert("Tidak ada data order")
        } else {
            return alert("Gagal mengambil data. Coba refresh atau ulangi beberapa saat lagi")
        }
    };

    return (
        <div className="bg-white rounded shadow">
            <div className="p-4 d-flex justify-content-between">
                <h5>Semua {props.match.params.status}</h5>
                <CSVLink
                    className="col-3 btn btn-sm btn-light"
                    separator={"|"}
                    filename={"file_orders-admin.csv"}
                    data={downloadOrders}>
                    Download
                </CSVLink>
            </div>
            <AdminOrderTable
                data={orders}
                loading={loading}
                onRefresh={() => window.location.reload()}
            />
        </div>
    )
};


export default AdminOrderByStatus;
